module.exports = __webpack_public_path__ + "images/checkGreenIconWhiteFill-064aabb0a32f2b7b13279141e99bf7bc.svg";